<template>
  <div class="bxKb" v-if="kbxmlc">
    <div class="box noBtn">
      <div class="clear">
        <div class="clear-box">
          <div style="display: flex">
            <p class="cont-title lf">唱标</p>
            <div class="rt">
              <el-input
                v-model="tbdwmc"
                class="input-with-select lf"
                style="width: 250px; margin: 0 10px"
                placeholder="投标单位名称"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getData"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              v-if="role == 'Z'"
              @click="openKeyDialog"
              :disabled="isNext"
              >参数设置</el-button
            >
            <el-button
              type="primary"
              v-if="role == 'Z' && isShowRecordBtn"
              @click="getRecord"
              >抽取结果</el-button
            >
            <el-button type="primary" @click="lookJjgg" :disabled="waitLoading"
              >查看竞价公告</el-button
            >
          </div>
        </div>

        <div class="red" style="padding-bottom: 10px">
          <div v-for="(item, index) in canshuArr" :key="index">
            <span style="margin-right: 30px"
              >{{ item.csmc }}{{ item.srz
              }}{{ item.srz == "" || item.srz == null ? "" : item.cshz }}</span
            >
          </div>
        </div>
        <table-tem
          :config="tableConfig"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
        </table-tem>
      </div>
      <el-button
        v-if="!isNext && role == 'Z'"
        :disabled="isNext"
        @click="bxNextBtn"
        type="primary lcNext"
        >下一步</el-button
      >
      <param-setting
        v-if="role == 'Z'"
        ref="paramSetting"
        :project="kbxm"
        :projectType="projectType"
        @success="getCscqnrStr"
      />
    </div>
    <el-dialog title="参数设置" :visible.sync="dialogVisible" width="30%">
      <div class="csBox" v-for="(item, index) in dialogCanshuArr" :key="index">
        <div>{{ item.csmc }}</div>
        <el-input v-model="item.srz" @change="handleInput(item)" :disabled="!canSet"></el-input>
        <div>{{ item.cshz }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button v-if="canSet" type="primary" @click="submitCssz">确 定</el-button>
      </span>
    </el-dialog>
    <draw-record ref="drawRecordRef" type="cb"></draw-record>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
  
  <script>
import tableTem from "@/components/tableTem/index.vue";
import ParamSettingMixin from "@/mixins/ParamSettingMixin";
import ParamSetting from "../components/ParamSetting";
import DrawRecord from "@/components/drawRecord/index.vue";

export default {
  mixins: [ParamSettingMixin],
  components: {
    tableTem,
    ParamSetting,
    DrawRecord,
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
    isNext() {
      return this.kbxmlc.zt == 2;
    },
  },
  data() {
    return {
      tbdwmc: "", //查询条件
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "fcqymc",
            title: "投标单位名称",
            align: "center",
          },
          {
            key: "fcbj",
            title: "投标报价",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
      bjgs: 0,
      zgs: 0,
      kbxmlc: {},
      kbxm: "",
      dialogVisible: false,
      unit: "",
      canshuArr: [],
      dialogCanshuArr: [],
      projectType: "", //项目大类1、采购项目 2、工程项目
      cscqnrStr: "", // 参数设置
      isShowRecordBtn: false, //是否显示抽取结果按钮
    };
  },
  watch:{
    unit(val){
      this.handleHead()
    }
  },
  async created() {
    this.djlcId = this.$route.query.djlcId;
    await this.getData();
    this.getProjectType();
  },
  methods: {
    async getCscqnrStr() {
      this.getlistAllCs();
    },
    async getProjectType() {
      try {
        const { data } = await this.$api.judgeType();
        this.projectType = data.data;
      } catch (err) {
        console.error("getProjectType fail", err);
      }
    },
    handleHead() {
      this.tableConfig.head.forEach((el) => {
        if (el.key == "fcbj") {
          el.title = `${el.title}(${this.unit})`;
        }
      });
    },
    handleInput(e) {
      e.srz = Number(e.srz).toFixed(2);
    },
    async getlistAllCs() {
      const res = await this.$api.listAllCs(this.kbxm.id);
      this.canshuArr = res.data.data;
    },
    async openKeyDialog() {
      // this.dialogCanshuArr = JSON.parse(JSON.stringify(this.canshuArr));
      // this.dialogVisible = true;
      this.$refs.paramSetting.open();
    },

    async submitCssz() {
      let param = [];
      let notAllow = false;
      this.dialogCanshuArr.forEach((el) => {
        console.log(Number(el.srz) >= 0 && Number(el.srz) <= 100);
        if (el.cshz == "%" && Number(el.srz) >= 0 && Number(el.srz) <= 100) {
          let obj = {};
          obj.csdm = el.csdm;
          obj.csmc = el.csmc;
          obj.cshz = el.cshz;
          obj.srz = el.srz;
          obj.kbxmId = this.kbxm.id;
          obj.bdId = this.kbxm.fgbdid;
          param.push(obj);
        } else if (
          el.cshz == "%" &&
          (Number(el.srz) <= 0 || Number(el.srz) >= 100)
        ) {
          notAllow = true;
        } else {
          let obj = {};
          obj.csdm = el.csdm;
          obj.csmc = el.csmc;
          obj.cshz = el.cshz;
          obj.srz = el.srz;
          obj.kbxmId = this.kbxm.id;
          obj.bdId = this.kbxm.fgbdid;
          param.push(obj);
        }
      });
      if (notAllow) {
        this.$message({
          type: "warning",
          message: "只允许输入0~100之间的值",
        });
        return;
      }
      const res = await this.$api.saveCscqnr(param);
      if (res.data.meta.success) {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.dialogVisible = false;
        this.canshuArr = this.dialogCanshuArr;
        this.getlistAllCs();
        let obj = {
          lx: "zb",
          data: {
            id: "",
          },
        };
        this.$emit("send", JSON.stringify(obj));
      } else {
        this.$message({
          type: "error",
          message: res.data.meta.message,
        });
      }
    },
    async lookJjgg() {
      const res = await this.$api.noticeView();
      let blob = new Blob([res.data], {
        type: "application/pdf",
      });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    getData() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
        currentPage: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize,
        isCb: 1,
      };
      this.waitLoading = true;
      this.$api
        .kblbList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableConfig.data = res.data.data.tbdwList;
            this.tableConfig.total = res.data.data.total;
            this.bjgs = res.data.data.bjgs;
            this.zgs = res.data.data.zgs;
            this.kbxmlc = res.data.data.kbxmlc;
            this.kbxm = res.data.data.kbxm;
            this.unit =
              res.data.data.tbdwList.length !== 0
                ? res.data.data.tbdwList[0].tbbjdw
                : "";
            this.isShowRecordBtn = res.data.data.sfcq;
            this.getlistAllCs();
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    bxNextBtn() {
      let allow = false;
      this.canshuArr.forEach((el) => {
        if (el.srz == "" || el.srz == null) {
          allow = false;
        } else {
          allow = true;
        }
      });
      if (!allow) {
        this.$message({
          type: "warning",
          message: "请先设置参数",
        });
        return;
      }
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("bxNextBtn", para);
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
    getRecord() {
      this.$refs.drawRecordRef.dialogVisible = true;
    },
  },
};
</script>
  
  <style lang='scss' scoped>
.clear {
  display: flex;
  flex-direction: column;
  &-box {
    display: flex;
    justify-content: space-between;
  }
}
.red {
  display: flex;
}
.csBox {
  display: flex;
  align-items: center;
  margin-right: 30px;
  margin-bottom: 20px;
  font-size: 16px;
  div {
    white-space: nowrap;
  }
  .el-input {
    margin: 0 8px;
    width: 200px;
  }
}
.pageNum {
  position: relative;
  bottom: 50px;
}
</style>
